import React from "react";
import Amar from "../assets/Amar.jpeg";

const AmarPage = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen p-6">
      {/* Contêiner principal */}
      <div className="flex flex-col md:flex-row items-center max-w-4xl w-full">
        {/* Imagem (sempre centralizada) */}
        <div className="w-full md:w-1/2 flex justify-center">
          <img
            src={Amar}
            alt="Amar"
            className="w-full h-auto rounded-lg shadow-lg"
          />
        </div>

        {/* Texto (sempre centralizado) */}
        <div className="w-full md:w-1/2 mt-6 md:mt-0 md:pl-8 text-center">
          <h1 className="text-3xl font-bold text-[#ad6a51] mb-4">
            Amar é verbo
          </h1>
          <p className="text-lg text-[#4a4a4a] leading-relaxed">
            <br />
            Amar - sentir . investir . dedicar . emocionar . tocar . escutar .
            ver . viver . "ar" ~ er ir!
            <br />
            <br />
            Amar é verbo, é movimento, é ação, é ser. Se preso, se perde. Vira
            coisa.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AmarPage;
